import React, { useEffect, useRef, useState } from 'react';
import { renderAsync } from 'docx-preview';

export default function DocxPreview({ url, thumbUrl, className = '' }) {
  const hostRef = useRef(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const container = hostRef.current;
    if (!url || !container) return;
    setLoading(true);
    setError(null);
    container.innerHTML = '';

    (async () => {
      try {
        const resp = await fetch(url, { credentials: 'include' });
        if (!resp.ok) throw new Error(await resp.text());
        const buf = await resp.arrayBuffer();
        if (cancelled) return;
        await renderAsync(buf, container, null, {
          className: 'docx',
          useBase64URL: true,
          // Keep fonts/layout simple for preview performance
          experimental: true,
        });
      } catch (e) {
        if (!cancelled) setError(e.message || 'Kunde inte rendera DOCX');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
      if (container) container.innerHTML = '';
    };
  }, [url]);

  return (
    <div className={`relative w-full h-full overflow-auto bg-white dark:bg-slate-900 ${className}`}>
      <div ref={hostRef} className="docx-preview px-4 py-3 text-[13px] leading-6 prose prose-sm max-w-none dark:prose-invert" />
      {loading && (
        <div className="absolute inset-0 grid place-items-center text-xs text-slate-500">Laddar…</div>
      )}
      {error && (
        <div className="p-4 text-center text-xs text-red-600 dark:text-red-400">
          <div>{error}</div>
          {thumbUrl && (
            <div className="mt-3 flex flex-col items-center gap-2 text-slate-500 dark:text-slate-300">
              <img src={thumbUrl} alt="Tumnagel" className="max-h-64 w-full rounded border border-slate-200 object-contain dark:border-slate-700" />
              <span className="text-[11px]">Visar tumnagel – fullständig förhandsvisning misslyckades.</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
